import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Pencil, Users } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { GroupMembersField, MemberList } from "@/components/offers/GroupMembersField";

// Abonnements: one group = one subscription with N mini-sites; admin can add / remove / swap members (immediate).
export const GroupBlock = ({ g, testId }) => {
  const { t } = useI18n();
  const [edit, setEdit] = useState(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/minisite/groups/${g.id}/members`, { members: edit.filter((m) => m.trim()) });
      toast.success(t("group.saved"));
      setEdit(null);
    } catch (err) {
      toast.error(translateError(err, t));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-w-0 space-y-2 rounded-xl border border-emerald-500/40 bg-emerald-950/20 p-3" data-testid={testId}>
      <div className="flex min-w-0 flex-wrap items-center justify-between gap-2">
        <p className="flex min-w-0 items-center gap-1.5 break-words text-xs font-bold uppercase tracking-wide text-emerald-200">
          <Users className="h-4 w-4 shrink-0" /> <span data-testid={`${testId}-title`}>{t("group.sites", { n: g.members.length, size: g.size })}</span>
        </p>
        {!edit && <button type="button" className="inline-flex items-center gap-1 text-xs text-[var(--gold-bright)] hover:text-white" onClick={() => setEdit(g.members)} data-testid={`${testId}-edit`}>
          <Pencil className="h-3.5 w-3.5" /> {t("group.edit")}</button>}
      </div>
      {edit ? (
        <>
          <GroupMembersField members={edit} onChange={setEdit} max={g.size} testId={`${testId}-field`} />
          <p className="break-words text-[0.7rem] text-neutral-400">{t("group.editHint")}</p>
          <div className="flex flex-wrap gap-2">
            <button type="button" className="btn-gold btn-sm" disabled={busy} onClick={save} data-testid={`${testId}-save`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} {t("group.save")}</button>
            <button type="button" className="btn-red btn-sm" onClick={() => setEdit(null)} data-testid={`${testId}-cancel`}>{t("group.cancel")}</button>
          </div>
        </>
      ) : <MemberList members={g.members} testId={`${testId}-members`} />}
    </div>
  );
};
